module.exports = __webpack_public_path__ + "img/20191019153920360截图20191019141417500.552398aa.jpg";